import { Link } from 'react-router-dom';
import { DashboardSidebarItemProps } from './DashboardSidebarItem.types';

export default ({
  icon: Icon,
  label,
  isActive,
  isCompany,
  to,
  ...props
}: DashboardSidebarItemProps) => {
  return (
    <Link to={to}>
      <div
        data-testid="dashboard-sidebar-item"
        className={`dashboard__sidebar-list-item${
          isActive ? ' dashboard__sidebar-list-item--active' : ''
        }${isCompany ? ' dashboard__sidebar-list-item--secondary' : ''}`}
        {...props}>
        <Icon />
        <label>{label}</label>
      </div>
    </Link>
  );
};
